import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { RefundsDashboardStore } from '../stores/refundsDashboardStore';

export const useRefundsDashboardStore = () =>
  useContext<{
    refundsDashboardStore: RefundsDashboardStore;
  }>(StoreContext);
